import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type TopicState = {
  customTopicsCount: number;
};

const initialState: TopicState = {
  customTopicsCount: 0,
};

export const topicSlice = createSlice({
  initialState,
  name: "topic",
  reducers: {
    setCustomTopicsCount: (state, action: PayloadAction<number>) => {
      state.customTopicsCount = action.payload;
    },
    incrementCustomTopicsCount: (state) => {
      ++state.customTopicsCount;
    },
    decrementCustomTopicsCount: (state) => {
      --state.customTopicsCount;
    },
  },
});
